import LoginBody from "@/components/landing/auth/LoginBody";

export default function LoginTwoBody() {
  return <LoginBody />;
}
